import { Component, Input } from '@angular/core';
import { PageResult } from '../../models/shared/page-result.model';

@Component({
  selector: 'ct-responsive-pagination',
  templateUrl: './responsive-pagination.component.html'
})
export class ResponsivePaginationComponent {
  @Input()
  page: PageResult<any>;
  @Input()
  enable: true;
  @Input()
  queryParams: any;
}
